module.exports = __webpack_public_path__ + "img/genesis-drop-impostor-1.147093ba.webp";